import { FC } from 'react'

import { getPositionName, getProjectName } from 'services/Utilities'
import { Format } from 'services/Dates'
import { DateTime } from 'components/UI'

import { t } from 'translations'

type Props = {
  punchCard: MData.PunchCard
  isBeforeOrToday: boolean
}

const PunchInformation: FC<Props> = ({ punchCard, isBeforeOrToday }) => {
  if (!punchCard && !isBeforeOrToday) return null

  const { arrival, leave, breaks = [], transfers = [] } = punchCard

  return (
    <div>
      <small className="text-primary font-weight-bold">{t('employee.mySchedule.PUNCH_INFORMATION')}</small>
      <div className="mt-2">
        {/* Arrival */}
        {arrival ? (
          <span key="arrival" className="mb-1 mr-2">
            <i className="fad fa-sign-in-alt mr-2" />
            {Format(arrival, { outFormat: 'time' })}
          </span>
        ) : null}

        {/* Leave */}
        {leave ? (
          <span key="leave" className="mb-1">
            <i className="fad fa-sign-out-alt mr-2" />
            {Format(leave, { outFormat: 'time' })}
          </span>
        ) : null}
      </div>
      {/* Breaks */}
      {breaks.length > 0
        ? breaks
            .filter(({ start }) => start)
            .map(({ start, end, _id }) => (
              <div key={_id} className="mb-1">
                <i className="fad fa-coffee mr-2" />
                <span>
                  {Format(start, { outFormat: 'time' })}
                  {end ? ` - ${Format(end, { outFormat: 'time' })}` : null}
                </span>
              </div>
            ))
        : null}
      {/* Transfers */}
      {transfers.length > 0
        ? transfers.map(({ toPosition, toProject, time, _id }) => (
            <div key={_id}>
              <i className="fad fa-exchange-alt mr-2" />
              {!!toPosition && <span className="mr-1">{`${getPositionName(toPosition)} -`}</span>}
              {!!toProject && <span className="mr-1">{`${getProjectName(toProject)} -`}</span>}
              <DateTime date={time} outFormat="time" />
            </div>
          ))
        : null}
    </div>
  )
}

export default PunchInformation
